var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-gray-900 whitespace-no-wrap"},[_vm._v("$"+_vm._s(_vm.data[_vm.name]))]),_c('p',{staticClass:"text-gray-600 whitespace-no-wrap"},[_vm._v("USD")])])}
var staticRenderFns = []

export { render, staticRenderFns }